import { TypeModel } from '@klant/conversational-connector/models/Type.model';

export type ChatMessageModel = PlainTextMessageModel | ChoicePromptMessageModel | ParticipantMessageModel | CTAMessageModel;
export type ChatMessageViewModel = ChatMessageModel & {
    messageDate?: Date;
    firstOfDate?: boolean;
    lastMessage?: boolean;
    showAvatar?: boolean;
};

export type ChatMessageEvent = {
    detail: ChatMessageEventDetail;
} & Event;

export type ChatMessageEventDetail = {
    chatMessage: string;
};

export interface PlainTextMessageModel {
    type: TypeModel.PLAIN_TEXT_MESSAGE;
    id?: string;
    text: string;
    fromClient: boolean;
    serviceName?: string;
    transactionId?: string;
    messageStatus?: MessageStatusModel;
    occurredAt?: number;
}

export interface CTAMessageModel {
    type: TypeModel.CTA_MESSAGE;
    id: string;
    buttonLink: string;
    buttonText: string;
    fromClient: boolean;
    transactionId: string;
    messageStatus: MessageStatusModel;
    occurredAt: number;
}

export interface ChoicePromptMessageModel {
    type: TypeModel.CHOICE_PROMPT_MESSAGE;
    id: string;
    choices: ChoiceOptionModel[];
    promptText: string;
    fromClient: boolean;
    transactionId: string;
    messageStatus?: MessageStatusModel;
    occurredAt?: number;
}

export interface ParticipantMessageModel {
    type: TypeModel.PARTICIPANT_MESSAGE;
    id: string;
    name: string;
    serviceName?: string;
    fromClient: boolean;
    introductionText: string;
    messageStatus: MessageStatusModel;
    transactionId: string;
    occurredAt: number;
}

export interface ChoiceOptionModel {
    id: string;
    text: string;
}

export enum MessageStatusModel {
    READ = 'read',
    RECEIVED = 'received'
}
